import React from 'react';
import { LegendProps } from 'recharts';
import { Stack } from '../../Stack/Stack';

interface Props extends LegendProps {
  labels?: string[];
}

export function ChartLegend({ payload, labels }: Props): JSX.Element | null {
  if (!payload) {
    return null;
  }
  return (
    <Stack line size="lg" justify="center">
      {payload.map(({ color, value }, idx) => (
        <Stack key={idx} line size="xxxs">
          <svg width="10px" height="10px">
            <circle cx="5" cy="5" r="4" fill={color} />
          </svg>
          <p>{labels?.[idx] || value}</p>
        </Stack>
      ))}
    </Stack>
  );
}
